import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'TemporaryTransferPill',
  props: {
    startDate: {},
    endDate: {}
  },
  setup(__props: any) {



const formatDate = (dateString: string): string => {
  const date = new Date(dateString)

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(date)
}

return (_ctx: any,_cache: any) => {
  const _component_sword_tag = _resolveComponent("sword-tag")!

  return (_openBlock(), _createBlock(_component_sword_tag, {
    color: "primary",
    icon: "hourglass",
    class: "w-full"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(formatDate(__props.startDate)) + " - " + _toDisplayString(formatDate(__props.endDate)), 1)
    ], undefined, true),
    _: 1
  }))
}
}

})